<template>
  <el-card class="yellow-widget">
    <div v-if="$slots.header" slot="header">
        <slot name="header"></slot>
    </div>
    <div class="row mt-4" style="max-height: 400px;">
      <bar-chart v-if="loaded" :data="datasets" :options="options" class="col-12 w-100"></bar-chart>
    </div>
    <div class="row mt-2">
      <div class="text-muted mx-auto small mb-1">All Totals are ex GST</div>
    </div>
  </el-card>
</template>


<script>
import BarChart from "./charts/BarChart";
export default {
  components: {
    BarChart
  },
  props: {
    token: {
      type: String,
      required: true
    },
    dateScope: {
      type: Object,
      required: true
    },
    teamId: {
      type: [Number, String],
      required: false
    },
    brokerId: {
        type: Number,
        required: false
    },
  },
  data() {
    return {
      totalIncomeByMonth: [],
      labels: [],
      datasets: [],
      loaded: false,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            xAxes: [{
                stacked: true,
                ticks: {
                    fontFamily: "Poppins",
                    padding: 5,
                    boxWidth: 15,
                    fontSize: 12,
                    fontColor: "#000",
                    fontStyle: "normal",
                    callback: function(value, index, values) {
                      let stringVal =  String(value);
                      return stringVal.substring(0, 3) + ' ' + stringVal.substring(stringVal.length - 4);
                    }
                }
            }],
            yAxes: [{
                stacked: true,
                ticks: {
                    fontFamily: "Poppins",
                    padding: 5,
                    boxWidth: 15,
                    fontSize: 12,
                    fontColor: "#000",
                    fontStyle: "normal",
                    suggestedMin: 0,
                    precision: 0,
                    callback: function(value, index, values) {
                      let commarize = this.commarize(String(value));
                      if (String(commarize).substring(0, 1) == '-') {
                        return '-$' + String(commarize).substring(1);
                      } else {
                        return '$' + commarize;
                      }
                    }.bind(this)
                }
            }]
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            fontFamily: "Poppins",
            padding: 10,
            boxWidth: 15,
            fontSize: 12,
            fontColor: "#000",
            fontStyle: "normal",
            filter: function(item, chart) {
                return !item.text.includes('To Date');
            }
          }
        },
        tooltips: {
          mode: 'label',
          titleFontFamily: "Poppins",
          titleFontSize: 13,
          titleMarginBottom: 15,
          bodyFontFamily: "Poppins",
          bodyFontSize: 13,
          bodySpacing: 10,
          footerFontFamily: "Poppins",
          footerFontStyle: "bold",
          footerFontSize: 13,
          footerMarginTop: 15,
          footerSpacing: 10,
          cornerRadius: 0,
          xPadding: 15,
          yPadding: 15,
          backgroundColor: 'rgba(8,7,48,0.8)',
          callbacks: {
            title: function(t, d) {
                let idx = t[0].index;
                return d.labels[idx];
            },
            label: function(t, d) {
              let dstLabel = d.datasets[t.datasetIndex].label.replace(/ .*/,'');
              let yLabel = t.yLabel;

              if (dstLabel == 'Referral')
                dstLabel = d.datasets[t.datasetIndex].label;

              if (yLabel == 0 || dstLabel == 'To')
                return;

              return ' ' + dstLabel + ': ' + Number(yLabel).toLocaleString("en-AU", { style: 'currency', currency: 'AUD' });
            },
            footer: function(t, d, v) {
              let sum = 0, toDate = t.shift();
              t.forEach(item => sum += Number(item.value));
              return 'Total: ' + sum.toLocaleString("en-AU", { style: 'currency', currency: 'AUD' });
            }
          }
        }
      }
    };
  },
  mounted() {
    this.refreshData();
  },
  created() {
    this.$bus.$on("refreshed-data", value => {
      this.refreshData();
    });
  },
  watch: {
    teamId: {
      handler(newVal, oldVal) {
        this.refreshData();
      },
      deep: true
    },
    brokerId: {
      handler(newVal, oldVal) {
        this.refreshData();
      },
      deep: true
    }
  },
  computed: {

    totalIncome() {
      return 0;
    }

  },
  methods: {
    refreshData() {
      this.getTotalIncomeByMonth();
    },
    async getTotalIncomeByMonth() {
      try {
        // this.loaded = false;
        let res = await axios.get(`/api/v2/total-income`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          },
          params: {
            startDate: this.$moment(this.dateScope.startDate).format('YYYY-MM-DD'),
            endDate: this.$moment(this.dateScope.endDate).format('YYYY-MM-DD'),
						teamId: this.teamId,
            brokerId: this.brokerId
          }
        });

        this.totalIncomeByMonth = res.data;

        let labels = Object.values(this.totalIncomeByMonth.labels);

        this.datasets = {
            datasets: [{
                label: 'To Date',
                borderColor: '#F44336',
                backgroundColor: '#F44336',
                borderWidth: 2,
                pointRadius: 0,
                pointHoverRadius: 0,
                data: Object.values(this.totalIncomeByMonth.values.toDate),
                type: 'line',
                fill: false,
                cubicInterpolationMode: 'monotone',
                borderDash: [2, 2],
            },{
                label: 'DOF',
                backgroundColor: '#00BCD4',
                data: Object.values(this.totalIncomeByMonth.values.dof)
            },{
                label: 'Finance Commission',
                backgroundColor: '#2196F3',
                data: Object.values(this.totalIncomeByMonth.values.financeCommission)
            },{
                label: 'Insurance Commission',
                backgroundColor: '#3F51B5',
                data: Object.values(this.totalIncomeByMonth.values.insuranceCommission)
            },{
                label: 'Referral Incoming',
                backgroundColor: '#ffbf00',
                data: Object.values(this.totalIncomeByMonth.values.referralIncoming)
            },{
                label: 'Referral Outgoing',
                backgroundColor: '#c621c6',
                data: Object.values(this.totalIncomeByMonth.values.referralOutgoing)
            },{
                label: 'Referral Vouchers',
                backgroundColor: '#8b188b',
                data: Object.values(this.totalIncomeByMonth.values.referralVouchers)
            }],
            labels: labels
        };
        this.loaded = true;

      } catch (err) {
        console.error(err);
      }
    },
    commarize(val, min) {
        min = min || 1e3;

        let isNeg = val < 0;
        let posNum = Math.abs(val);

        // Alter numbers larger than 1k
        if (posNum >= min) {
          var units = ["k", "M", "B", "T"];

          var order = Math.floor(Math.log(posNum) / Math.log(1000));

          var unitname = units[(order - 1)];
          var num = Math.floor(posNum / 1000 ** order);

          if (String(num).length == 1) {
            num = Number(posNum / 1000 ** order).toFixed(1);
            if (num == Number(num)) {
              num = Number(num);
            }
          }

          if (isNeg)
            num = 0 - Number(num);

          return num + unitname;
        }

        if (isNeg)
          posNum = 0 - posNum;

        val = posNum;

        return val.toLocaleString();
    }
  }
};
</script>
